import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import CoreuiVue from '@coreui/vue'
import VCalendar from 'v-calendar'
import { iconsSet as icons } from './assets/icons/icons.js'
import VMdDateRangePicker from 'v-md-date-range-picker'
import VueAnalytics from 'vue-analytics'
import 'regenerator-runtime'
// Import the Firebase services object that exports both app instances' services
import firebaseServices from './firebaseInit'
import i18n from './plugins/i18n'
import VueCarousel from 'vue-carousel';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueLazyload from 'vue-lazyload';

Vue.config.performance = true
Vue.config.productionTip = false
Vue.use(CoreuiVue)
Vue.use(VCalendar)
Vue.use(VueCarousel);


Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: process.env.VUE_APP_NOIMAGE,
  attempt: 1
});


Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    libraries: 'places',
    async: true,
    defer: true,
  },
});

Vue.use(VMdDateRangePicker)
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_ANALYTICS,
  router,
})

let app = ''

// Use the auth instance from the default Firebase app for onAuthStateChanged
// If you intended this listener to be for the 'CustomerProfile' app,
// you would use firebaseServices.customerProfile.auth instead.
firebaseServices.default.auth.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      icons,
      i18n,
      render: (h) => h(App),
    }).$mount('#app')
  }
})

